import { render, staticRenderFns } from "./input-consequence.vue?vue&type=template&id=1ba241e0&scoped=true&"
import script from "./input-consequence.vue?vue&type=script&lang=js&"
export * from "./input-consequence.vue?vue&type=script&lang=js&"
import style0 from "./input-consequence.vue?vue&type=style&index=0&id=1ba241e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba241e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ba241e0')) {
      api.createRecord('1ba241e0', component.options)
    } else {
      api.reload('1ba241e0', component.options)
    }
    module.hot.accept("./input-consequence.vue?vue&type=template&id=1ba241e0&scoped=true&", function () {
      api.rerender('1ba241e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input-consequence.vue"
export default component.exports